import { useEffect } from "react";

import { Nav, Footer } from "../components/Nav";
import Cover from "../images/HoneyBuddy/HoneyBuddy Cover.png";
import wireframe from "../images/HoneyBuddy/HoneyBuddy Wireframes.png";
import initialColor from "../images/HoneyBuddy/Logo and Starting Colors.png";
import brainstorm from "../images/HoneyBuddy/HoneyBuddy Brainstorm.png";
import sytleGuide from "../images/HoneyBuddy/HoneyBuddy Style Guide.png";
import onboardingGif from "../images/HoneyBuddy/HB Onboarding.gif";
import preferenceImg from "../images/HoneyBuddy/HB Preferences.png";
import loginImg from "../images/HoneyBuddy/HB Login.png";
import goalsPage from "../images/HoneyBuddy/HB Goals.png";
import challengePage from "../images/HoneyBuddy/HB Challenge.png";
import goalsGif from "../images/HoneyBuddy/HB Goals Gif.gif";
import chatbotGif from "../images/HoneyBuddy/HB Chatbot Gif.gif";
import notificationGif from "../images/HoneyBuddy/HB Widget and Notification.gif";
import widgetImg from "../images/HoneyBuddy/HB Widget.png";
import notificationImg from "../images/HoneyBuddy/HB Notification.png";
import finalImg from "../images/HoneyBuddy/HoneyBuddy Final.png";
import {
  ProjectInfo,
  BigStatement,
  TextSection,
  MoreSection,
  CardGrid,
} from "../components/ProjectDetails";

export default function HoneyBuddy() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <>
      <Nav color="white" />

      <header id="project-cover" className="hb">
        <h1 className="accent-text">HoneyBuddy</h1>
        <p>Awarded Best User Interface at the 2025 Rice Design-a-Thon.</p>
        <p>
          Mobile habit and goal app to help busy college students achieve their
          goals.
        </p>
        <img id="cover" src={Cover} alt="HoneyBuddy Mockup" />
      </header>

      <main id="project-detail-main" className="hb">
        <ProjectInfo
          role={["UX Designer", "UX Researcher"]}
          team={["3 Designers", "Ashley Cha", "Hayoung Ryow"]}
          toolkit={["Figma", "Miro", "Adobe Illustrator"]}
          duration="2 Days (2025)"
        />
        <BigStatement header="Problem Statement">
          College students, overwhelmed by busy schedules and stress, lack
          motivation and struggle to maintain healthy lifestyle habits.
        </BigStatement>
        <TextSection
          type="callout first-section last-section"
          header="Solution"
          title="HoneyBuddy"
        >
          <p>
            AI-powered habit tracking and gamified community challenges to make
            goal achievement effortless and fun for busy students by integrating
            micro-habits directly into their day.
          </p>
          <a
            className="primary-button accent-btn"
            href="https://www.figma.com/proto/GwkI3HEFFJcR1iOkW4oYEX/HoneyBuddy-(Mandy-Version)?page-id=3%3A2&node-id=183-1436&p=f&viewport=100%2C-364%2C0.32&t=7fAKYNoThLvFvntA-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=183%3A1436"
            target="_blank"
            rel="noopener noreferrer"
          >
            Figma Prototype
          </a>
          <h1>My Key Contributions</h1>
          <ul>
            <li>
              <span className="accent-text">Strategic Problem Solving </span>{" "}
              &#8594; Led the concept ideation by synthesizing user research
              insights to identify key user pain points: lack of motivation and
              structure. I then created feature sets (community challenges,
              badges and streaks) to address these pain points.
            </li>
            <br />
            <li>
              <span className="accent-text">Interaction Design & Flow </span>{" "}
              &#8594; Designed and tested key pages (Challenges, Goals, and
              Chatbot) by focusing on simple layout and clear navigation so
              users can effortlessly complete tasks.
            </li>
            <br />
            <li>
              <span className="accent-text">Prototype & Design System </span>{" "}
              &#8594; Built the working prototype (over 70% of the final design)
              and established the comprehensive Style Guide for usability and
              consistency.
            </li>
          </ul>
        </TextSection>
        <TextSection
          type="normal-text first-section"
          header="Brainstorming"
          title="Generating Research Questions & Narrowing Down Scope"
        >
          <img src={brainstorm} alt="HoneyBuddy Brainstorming in Miro"></img>
        </TextSection>
        <TextSection
          type="normal-text"
          header="User Research & Insights"
          title=" Understanding College Students’ Lifestyle Challenges"
        >
          <p>11 one-on-one user interviews and 47 survey responses.</p>
          <br />
          <p>
            <strong>Top Findings:</strong>
          </p>
          <CardGrid>
            <p>
              90% of students want to improve, but lack of time and motivation
              are the biggest hindering factors.
            </p>
            <p>
              70% of students have their phones within arm's reach nearly 100%
              of the time.
            </p>
            <p>
              80.9% of students self-reported their stress levels being high.
            </p>
            <p>Most wanted improvements are eating healthy and exercising</p>
          </CardGrid>
        </TextSection>
        <TextSection
          type="normal-text"
          header="ideation"
          title="Turning Insights Into Features"
        >
          <p>
            <strong className="accent-text">Mobile App and Widget </strong>
            &#8594; Leveraging student's constant phone access for low-friction
            visual cues.
          </p>
          <p>
            <strong className="accent-text">Weekly Challenges </strong>
            &#8594; Social engagement provides external motivation and
            accountability while making goal achievement more fun.
          </p>
          <p>
            <strong className="accent-text">
              AI Chatbot to Create New Goals{" "}
            </strong>
            &#8594; Allows students to set personalized goals quickly and easily
            without navigating complex forms, reducing cognitive load.
          </p>
          <p>
            <strong className="accent-text">Personalized Reminders </strong>
            &#8594; Tailored notifications help students stay on track with
            their goals without the need for active planning.
          </p>
          <p>
            <strong className="accent-text">
              Badges and Streaks as Motivation
            </strong>
            &#8594; Gamified elements provide motivation and a sense of
            achievement.
          </p>
        </TextSection>
        <TextSection
          type="normal-text last-section"
          header="planning"
          title="Logo and Starting Colors"
        >
          <p>
            The hive and honeycomb theme symbolizes community and togetherness
            while yellow and oranges convey a fun and friendly mood.
          </p>
          <img src={initialColor} alt="HoneyBuddy Initial Colors"></img>
        </TextSection>
        <TextSection
          type="normal-text last-section"
          header="ideation"
          title="Wireframing"
        >
          <p>
            Wireframing allows for quick iterations and incorporation of
            features we developed through research insights.
          </p>
          <img src={wireframe} alt="HoneyBuddy Wireframe"></img>
        </TextSection>
        <TextSection
          type="callout first-section"
          header="Style Guide"
          title="Honeycomb-Inspired Elements and Expanded Colors"
        >
          <img src={sytleGuide} alt="HoneyBuddy Final Style Guide"></img>
          <p>
            I led and developed the guide by expanding the color palette,
            selecting a modern font and creating new and cohesive elements that
            appeal to students.
          </p>
        </TextSection>
        <TextSection type="callout" header="Prototype" title="Try  HoneyBuddy">
          <a
            className="primary-button accent-btn"
            href="https://www.figma.com/proto/GwkI3HEFFJcR1iOkW4oYEX/HoneyBuddy-(Mandy-Version)?page-id=3%3A2&node-id=183-1436&p=f&viewport=100%2C-364%2C0.32&t=7fAKYNoThLvFvntA-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=183%3A1436"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginTop: "1rem" }}
          >
            Figma Prototype
          </a>
        </TextSection>
        <TextSection type="callout" header="Final Design" title="Onboarding">
          <p>
            I narrowed down the onboarding flow to collecting only essential
            information and preferences.
          </p>
          <div className="three-img">
            <img src={loginImg} alt="HoneyBuddy Login Page"></img>
            <img src={onboardingGif} alt="HoneyBuddy Onboarding Gif"></img>
            <img src={preferenceImg} alt="HoneyBuddy Preference Page"></img>
          </div>
        </TextSection>

        <TextSection
          type="callout"
          header="Final Design"
          title="Weekly Challenges & Personal Goals"
        >
          <p>
            Weekly challenges are designed to inspire and motivate students to
            achieve a healthy lifestyle together with their community. Streaks
            and badges also provide additional motivation for students to keep
            up with their goals.
          </p>

          <div className="three-img">
            <img
              src={challengePage}
              alt="HoneyBuddy Weekly Challenges Page"
            ></img>
            <img src={goalsGif} alt="HoneyBuddy Challenge and Goals Gif"></img>
            <img src={goalsPage} alt="HoneyBuddy Goals Page"></img>
          </div>
          <p>
            The Goals page allows users to create personal goals, each fitting
            into a slot within the honeycomb. As users add more goals, their
            hive expands, symbolizing how small habits accumulate into
            meaningful achievements.
          </p>
        </TextSection>

        <TextSection type="callout" header="Final Design" title="AI Chatbot">
          <div className="sidebyside">
            <img src={chatbotGif} alt="HoneyBuddy Chatbot Gif"></img>
            <p>
              Using an AI chatbot instead of a traditional form-style
              goal-setting approach offers greater flexibility. Users can share
              the goals they want to achieve and the chatbot provides
              personalized suggestions on how to accomplish them based on their
              current habits.
            </p>
          </div>
        </TextSection>

        <TextSection
          type="callout last-section"
          header="Final Design"
          title="Widget & Notification"
        >
          <p>
            To accommodate college students' busy schedules, we aim to create
            the most effortless way to achieve goals. This is achieved through a
            home screen widget that delivers visual reminders and notifications
            that provide periodic encouragement.
          </p>
          <div className="three-img">
            <img src={widgetImg} alt="HoneyBuddy Widget Page"></img>
            <img
              src={notificationGif}
              alt="HoneyBuddy Notification and Widget Gif"
            ></img>
            <img src={notificationImg} alt="HoneyBuddy Notifcation "></img>
          </div>
          <p>
            Additionally, the app leverages data such as screen time and motion
            to offer lifestyle suggestions through notifications. Some examples
            are: "take a walk" or "put the phone down for a break."
          </p>
        </TextSection>

        <TextSection
          type="normal-text first-section last-section"
          header="Final Design"
          title="All Design Pages"
        >
          <img
            src={finalImg}
            className="full-width-img"
            alt="Final HoneyBuddy Designs"
          />
        </TextSection>
      </main>
      <MoreSection exclude={["honeybuddy"]} />

      <Footer color="pink" />
    </>
  );
}
